// extracted by mini-css-extract-plugin
module.exports = {"trending":"PIfNo","astrendinglist":"nwwaV","trending_list":"u0lv3","newslisttrending":"fJdFn","infocuskeywordlist":"otYir","title":"_sda4","link_list_light":"kdxO6"};